import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { Block } from 'shared/components/Block';
import { BigTitle } from 'shared/components/BigTitle';
import { FiveOrSixUtpBlock } from 'shared/components/FiveOrSixUtpBlock';
import { UTP } from './constants';
import { NavigationButtons } from 'shared/components/NavigationButtons';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';
import { BTN_CORE_BUSINESS_LINK, BTN_TECHNOLOGIES_LINK, BTN_TRANSACTIONAL_LINK } from 'shared/constants/links';

export const OurAdvantages: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <Element name={ENavigation.AdvantagesDaily}>
          <Block gap={44}>
            <BigTitle text="Наши преимущества" />
            <FiveOrSixUtpBlock theme="blue" items={UTP} />
          </Block>
        </Element>
        <NavigationButtons
          withOutMarginBottom
          links={[BTN_TECHNOLOGIES_LINK, BTN_CORE_BUSINESS_LINK, BTN_TRANSACTIONAL_LINK]}
        />
      </Wrapper>
    </div>
  );
};
